module.exports = __webpack_public_path__ + "img/blog.c72f07a7.svg";